<template>
  <div>
    <v-row>
      <v-col cols="6" sm="3" md="2">
        <FormattedNumberField
          label="January"
          :value="revenueLogItemsValue[0].revenue"
          :hide-details="true"
          prepend-inner-icon="attach_money"
          :readonly="readonly"
          @valueChange="(newValue) => this.revenueLogItemsValue[0].revenue = newValue"
        ></FormattedNumberField>
      </v-col>
      <v-col cols="6" sm="3" md="2">
        <FormattedNumberField
          label="February"
          :value="revenueLogItemsValue[1].revenue"
          :hide-details="true"
          prepend-inner-icon="attach_money"
          :readonly="readonly"
          @valueChange="(newValue) => this.revenueLogItemsValue[1].revenue = newValue"
        ></FormattedNumberField>
      </v-col>
      <v-col cols="6" sm="3" md="2">
        <FormattedNumberField
          label="March"
          :value="revenueLogItemsValue[2].revenue"
          :hide-details="true"
          prepend-inner-icon="attach_money"
          :readonly="readonly"
          @valueChange="(newValue) => this.revenueLogItemsValue[2].revenue = newValue"
        ></FormattedNumberField>
      </v-col>
      <v-col cols="6" sm="3" md="2">
        <FormattedNumberField
          label="April"
          :value="revenueLogItemsValue[3].revenue"
          :hide-details="true"
          prepend-inner-icon="attach_money"
          :readonly="readonly"
          @valueChange="(newValue) => this.revenueLogItemsValue[3].revenue = newValue"
        ></FormattedNumberField>
      </v-col>
      <v-col cols="6" sm="3" md="2">
        <FormattedNumberField
          label="May"
          :value="revenueLogItemsValue[4].revenue"
          :hide-details="true"
          prepend-inner-icon="attach_money"
          :readonly="readonly"
          @valueChange="(newValue) => this.revenueLogItemsValue[4].revenue = newValue"
        ></FormattedNumberField>
      </v-col>
      <v-col cols="6" sm="3" md="2">
        <FormattedNumberField
          label="June"
          :value="revenueLogItemsValue[5].revenue"
          :hide-details="true"
          prepend-inner-icon="attach_money"
          :readonly="readonly"
          @valueChange="(newValue) => this.revenueLogItemsValue[5].revenue = newValue"
        ></FormattedNumberField>
      </v-col>
      <v-col cols="6" sm="3" md="2">
        <FormattedNumberField
          label="July"
          :value="revenueLogItemsValue[6].revenue"
          :hide-details="true"
          prepend-inner-icon="attach_money"
          :readonly="readonly"
          @valueChange="(newValue) => this.revenueLogItemsValue[6].revenue = newValue"
        ></FormattedNumberField>
      </v-col>
      <v-col cols="6" sm="3" md="2">
        <FormattedNumberField
          label="August"
          :value="revenueLogItemsValue[7].revenue"
          :hide-details="true"
          prepend-inner-icon="attach_money"
          :readonly="readonly"
          @valueChange="(newValue) => this.revenueLogItemsValue[7].revenue = newValue"
        ></FormattedNumberField>
      </v-col>
      <v-col cols="6" sm="3" md="2">
        <FormattedNumberField
          label="September"
          :value="revenueLogItemsValue[8].revenue"
          :hide-details="true"
          prepend-inner-icon="attach_money"
          :readonly="readonly"
          @valueChange="(newValue) => this.revenueLogItemsValue[8].revenue = newValue"
        ></FormattedNumberField>
      </v-col>
      <v-col cols="6" sm="3" md="2">
        <FormattedNumberField
          label="October"
          :value="revenueLogItemsValue[9].revenue"
          :hide-details="true"
          prepend-inner-icon="attach_money"
          :readonly="readonly"
          @valueChange="(newValue) => this.revenueLogItemsValue[9].revenue = newValue"
        ></FormattedNumberField>
      </v-col>
      <v-col cols="6" sm="3" md="2">
        <FormattedNumberField
          label="November"
          :value="revenueLogItemsValue[10].revenue"
          :hide-details="true"
          prepend-inner-icon="attach_money"
          :readonly="readonly"
          @valueChange="(newValue) => this.revenueLogItemsValue[10].revenue = newValue"
        ></FormattedNumberField>
      </v-col>
      <v-col cols="6" sm="3" md="2">
        <FormattedNumberField
          label="December"
          :value="revenueLogItemsValue[11].revenue"
          :hide-details="true"
          prepend-inner-icon="attach_money"
          :readonly="readonly"
          @valueChange="(newValue) => this.revenueLogItemsValue[11].revenue = newValue"
        ></FormattedNumberField>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { FormattedNumberField } from '@/components/shared/textFields'

export default {
  components: {
    FormattedNumberField
  },
  props: [
    'revenueLogItems',
    'readonly'
  ],
  computed: {
    revenueLogItemsValue: {
      get () {
        return this.revenueLogItems
      },
      set (newValue) {
        this.$emit('revenueLogItemsChange', newValue)
      }
    }
  }
}
</script>
